import { b, a } from './chunk-FUQLNXR2.mjs';
import { jsx } from 'react/jsx-runtime';

var l=e=>jsx("svg",b(a({xmlns:"http://www.w3.org/2000/svg",height:"1em",viewBox:"0 0 512 512"},e),{children:jsx("path",{d:"M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-352a96 96 0 1 1 0 192 96 96 0 1 1 0-192z",fill:"currentColor"})})),p=l;

export { p as a };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-LXXHA4G2.mjs.map